import { DefaultService } from '@/services/DefaultService';

export default class VenProdutoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    /* ABA GERAL */

    loadName(id) {
		return this._http.get(`${this._env}/product/name.json?id=${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    loadGeral (idProduto) {
        return this._http.get(`${this._env}/product/${idProduto}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    // @84571 - criado esse metodo para desacoplar as regras da aba geral. o método loadGeral será descontinuado.
    findById(idProduto) {
        return this._http.get(`${this._env}/product/${idProduto}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    loadProdutos (page, limit, q) {
        return this._http.get(`${this._env}/product.json?page=${page}&limit=${limit}&param=${q}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllCombo(limit = 50, q = ".*") {
        return this._http.get(`${this._env}/sales/package/product/findallcomboproduto.json?&limit=${limit}&param=${q}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    loadComboProdutosPaginado (page, limit, query) {
        return this._http.get(`${this._env}/product/findAllComboPaginado.json?page=${page}&limit=${limit}&param=${query}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    loadTarjaItem(){
        return this._http.get(`${this._env}/vendas/preco/getByIdComTarjaItem.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    loadComboProdutos (idsempresas, limit, q) {
        return this._http.get(`${this._env}/product/getcombo.json?idsempresas=${idsempresas}&limit=${limit}&param=${q}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    /* ABA PREÇO */

    loadPreco (idproduto, idempresa, column, order, page, limit, situacao, ...param) {
        return this._http.get(`${this._env}/vendas/preco.json?idempresa=${idempresa}&idproduto=${idproduto}&column=${column}&order=${order}&situacao=${situacao}&page=${page}&limit=${limit}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    /* ABA ESTOQUE */

    // loadEstoque (idProduto, page = 0, limit = 50) {
    //     return this._http.get(`${this._env}/sales/saldoproduto.json?page=${page}&limit=${limit}&idproduto=${idProduto}`, this._headers).then(res => {
    //         return res.body.content;
    //     }, err => {
    //         this.verifyError(err);
    //         throw new Error('Problems while jobs are loading');
    //     });
    // }

    loadLote (idProduto, page = 0, limit = 50) {
        return this._http.get(`${this._env}/sales/loteproduto.json?page=${page}&limit=${limit}&idproduto=${idProduto}`, this._headers).then(res => {
            return res.body.content;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    /* ABA UNIDADE DE MEDIDA */
    updateSituacaoUnitMedida (assprodutounidademedida) {
        return this._http.post(`${this._env}/sales/product/unitofupdatesituacao`, assprodutounidademedida, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    /* DEPRECIADO */
    loadUnMedida (idproduto) {
        return this._http.get(`${this._env}/sales/product/${idproduto}/unitofmeasurement.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }  
    
    loadUnidadesMedidas (idproduto, situacao, page = 0, limit = 50, order = 'asc', column = 'descricao', ...param) {
        return this._http.get(`${this._env}/sales/product/unitsofmeasurement.json?situacao=${situacao}&page=${page}&limit=${limit}&idproduto=${idproduto}&param=${param}&order=${order}&column=${column}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }  

    loadUnidadesMedidasDisponiveis (idproduto, page = 0, limit = 50, ...param) {
        return this._http.get(`${this._env}/sales/product/unitsofmeasurement/available.json?page=${page}&limit=${limit}&idproduto=${idproduto}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }  

    addUnMedida (assprodutounidademedida) {
        return this._http.post(`${this._env}/sales/product/unitofmeasurement`, assprodutounidademedida, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    addListUnMedidas (list) {
        return this._http.post(`${this._env}/sales/product/unitsofmeasurements`, list, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delUnMedida (id) {
        return this._http.delete(`${this._env}/sales/product/unitofmeasurement/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    /* ABA SIMILARES E AGREGADOS */

    loadSimilaresAgregados (idproduto) {
        return this._http.get(`${this._env}/sales/product/${idproduto}/similarandagregatedproduct.json?page=${0}&limit=${50}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    listAllSimilaresByIdProduto (idproduto, column, page = 0, limit = 50, order = 'asc', situacao, ...param) {
        return this._http.get(encodeURI(`${this._env}/ven/product/${idproduto}/similarproduct.json?page=${page}&limit=${limit}&order=${order}&column=${column}&situacao=${situacao}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    listAllSimilares (page = 0, limit = 50, ...param) {
        return this._http.get(encodeURI(`${this._env}/agro/product/similarproduct.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    listAllSimilaresNaoVinculados(column, order, page = 0, limit =50, idsimilar, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/product/similarproduct/naoassociado?page=${page}&limit=${limit}&order=${order}&column=${column}&idproduto=${idsimilar}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    loadSimilaresDisponiveis (idproduto, page = 0, limit = 50, ...param) {
        return this._http.get(`${this._env}/agro/product/${idproduto}/similarproduct.json?page=${page}&limit=${limit}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    addSimilar (produto) {
        return this._http.post(`${this._env}/agro/product/similarproduct`, produto, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    addSimilarInProduct (produto) {
        return this._http.post(`${this._env}/ven/product/similarproduct`, produto, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(produto) {
        return this._http.post(`${this._env}/ven/product/similar/updatesituacao`, produto, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    
    updateSituacaoAgregado(produto) {
        return this._http.post(`${this._env}/agro/product/agregatedproduct/updatesituacao`, produto, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delSimilar (idproduto) {
        return this._http.delete(`${this._env}/agro/product/similarproduct/${idproduto}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    loadAgregados (idproduto, column, order, page = 0, limit = 20, situacao, ...param) {
        return this._http.get(`${this._env}/sales/product/${idproduto}/allagregatedproducts.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    loadAllAgregadosDisponiveis (idproduto, column, order = 'asc', page = 0, limit = 20, ...param) {
        return this._http.get(`${this._env}/sales/product/${idproduto}/allavailableagregatedproducts.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    /* DEPRECIADO */
    loadAgregadosDisponiveis (idproduto, page = 0, limit = 50, ...param) {
        return this._http.get(`${this._env}/agro/product/${idproduto}/agregatedproduct.json?page=${page}&limit=${limit}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    addAgregado (produto) {
        return this._http.post(`${this._env}/agro/product/agregatedproduct`, produto, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    addListAgregados (produtos) {
        return this._http.post(`${this._env}/agro/product/list/agregatedproducts`, produtos, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delAgregado (idproduto) {
        return this._http.delete(`${this._env}/agro/product/agregatedproduct/${idproduto}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    /* ABA OBSERVAÇÕES */

    loadObservacoes (idProduto) {
        return this._http.get(`${this._env}/product/${idProduto}/notes.json`, this._headers).then(res => {
            return res.body.content;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    /* ABA INFORMAÇÕES TRIBUTÁRIAS */

    loadInfTrib (idProduto) {
        return this._http.get(`${this._env}/product/taxinformation/${idProduto}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    /* ABA FORNECEDORES */

    loadFornecedores (idProduto) {
        return this._http.get(`${this._env}/general/${idProduto}/provider.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    /* ABA CONFIGURAÇÕES */

    loadConfig (idProduto) {
        return this._http.get(`${this._env}/product/${idProduto}/settings.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    loadTabelasPreco (page = 0, limit = 50, ...param) {
        return this._http.get(`${this._env}/vendas/tabpreco.json?page=${page}&limit=${limit}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    loadDescontos (column, order, page, limit, situacao, idproduto, ...param) {
        return this._http.get(`${this._env}/product/${idproduto}/produtoqtdepreco?column=${column}&order=${order}&page=${page}&limit=${limit}&situacao=${situacao}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    saveDesconto (desconto) {
        return this._http.post(`${this._env}/product/produtoqtdepreco`, desconto, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    saveGrade (produto) {
        return this._http.post(`${this._env}/product/grid`, produto, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delDesconto (idProdutoQtdePreco) {
        return this._http.delete(`${this._env}/product/produtoqtdepreco/${idProdutoQtdePreco}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    loadMultiplicadores (idProduto) {
        return this._http.get(`${this._env}/product/${idProduto}/company`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    saveMultiplicador (mult) {
        return this._http.post(`${this._env}/product/company/multiplierweb`, mult, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delMultiplicador (idAssProdutoEmpresa) {
        return this._http.delete(`${this._env}/product/company/multiplierweb/${idAssProdutoEmpresa}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    saveConfig (config) {
        return this._http.post(`${this._env}/product/settings`, config, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    /* ABA CULTURA */

    loadCulturas (idProduto) {
        return this._http.get(`${this._env}/agro/${idProduto}/tipocultura.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    loadCulturasDisponiveis (idproduto, page, limit, ...params) {
        return this._http.get(`${this._env}/agro/tipocultura/product.json?page=${page}&limit=${limit}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    /* NÃO EXISTE NO BACKEND */
    addCulturasAoProduto (asscultura) {
        return this._http.post(`${this._env}/agro/product/tipocultura`, asscultura, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    removerCulturasDoProduto (idasscultura) {
        return this._http.delete(`${this._env}/agro/tipocultura/${idasscultura}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateCulturasDoProduto (culturas, idProduto) {
        return this._http.post(`${this._env}/agro/tipocultura/associate`, culturas, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    /* ABA LICENÇA */

    loadLicenca (idProduto) {
        return this._http.get(`${this._env}/sales/product/${idProduto}/license.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    loadLicencasDisp (idProduto, page = 0, limit = 50, ...param) {
        return this._http.get(`${this._env}/sales/product/not-license.json?page=${page}&limit=${limit}&param=${idProduto};${param.length ? param : '.*'}`,  this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    addLicenca (licenca) {
        return this._http.post(`${this._env}/sales/product/license`, licenca, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delLicenca (licenca) {
        return this._http.delete(`${this._env}/sales/product/license/${licenca.idassprodutolicenca}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    /* ABA GRADE */

    loadGrade (idProduto) {
        return this._http.get(`${this._env}/sales/product/${idProduto}/grid.json`, this._headers).then(res => {
            return res.body.content;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    // ABA PREÇO

    updatePrecoSituacao(assPrecoProduto) {
        return this._http.post(`${this._env}/vendas/preco/updatesituacao.json`, assPrecoProduto, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    
    getByIdAssTabPrecoProduto(id){
        return this._http.get(`${this._env}/vendas/preco/${id}.json`, this._headers).then(res => {
            return res.body.content;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    salvarAssTabPrecoProdutoComTag(obj) {
        return this._http.post(`${this._env}/vendas/preco/salvartabprecoprodutotag`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    save(tipo) {
        return this._http.post(`${this._env}/vendas/preco`, tipo, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllComboPreco(idproduto, idempresa, idtabpreco, search) {
        return this._http.get(`${this._env}/vendas/preco/combo.json?idproduto=${idproduto}&idempresa=${idempresa}&idtabpreco=${idtabpreco}&search=${search}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    // ABA IMAGENS
    
    listProdutoImages( idproduto, page, limit ){
        return this._http.get(`${this._env}/sales/product/${idproduto}/images.json?&page=${page}&limit=${limit}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });    
    }

    // Listagem Produto Catalogo

    loadComboProdutosByImageName (idsempresas, imagens ) {
        return this._http.get(`${this._env}/product/getcombo/byimagename.json?idsempresas=${idsempresas}&imgnames=${imagens}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}